import React, { useEffect, useState } from 'react';
import Header from "./header/Header";
import Footer from "./footer/Footer";

const Layout = ({ children }) => {
    const [siteSettings, setSiteSettings] = useState(null);


    // console.log("dd", socialLinks);
    useEffect(() => {
        const fetchSiteSettings = async () => {
            try {
                const response = await fetch('https://rss.fastwebforge.com/api/site-settings');
                const data = await response.json();
                setSiteSettings(data);
            } catch (error) {
                console.error('Error fetching site settings:', error);
            }
        };

        fetchSiteSettings();
    }, []);
    


 

   

    return (
        <>
            <main className="main">
                <Header siteSettings={siteSettings}  />
                {children}
                <Footer siteSettings={siteSettings}  />
            </main>
        </>
    );
};

export default Layout;